import { FC, useState } from "react";

import { OutcomeExportDialog } from "./OutcomeExportDialog";
import { OutcomeImportDialog } from "./OutcomeImportDialog";

import { OrgType } from "components/server-types";
import { t } from "i18n/i18n";
import { SquareButton } from "mds/components/buttons/SquareButton";
import { ArrowDownToLineIcon, ArrowUpFromLineIcon } from "mds/icons";
import { useCapabilities } from "store/capability-hooks";
import { useAppSelector } from "store/index";
import { selectCurrentOrg } from "store/selectors";
import { WaffleFlags, isWaffleFlagEnabled } from "utils/waffle-flags";

export const OutcomeTransferActions: FC = () => {
  const org = useAppSelector(selectCurrentOrg);
  const { canTransferOutcomeTrees } = useCapabilities();

  if (!org || !canTransferOutcomeTrees || !isWaffleFlagEnabled(WaffleFlags.OUTCOME_TREE_TRANSFER)) {
    return null;
  }

  // Remounting closes any open dialog and aborts its request when the organization changes.
  return <OrgOutcomeTransferActions key={org.id} org={org} />;
};

const OrgOutcomeTransferActions: FC<{ org: OrgType }> = ({ org }) => {
  const [transferMode, setTransferMode] = useState<"export" | "import">();

  return (
    <div className="flex flex-wrap justify-end gap-2 py-3">
      <SquareButton kind="secondary" size="s" onClick={() => setTransferMode("export")}>
        <ArrowUpFromLineIcon />
        {t("outcome_transfer.export")}
      </SquareButton>
      <SquareButton kind="secondary" size="s" onClick={() => setTransferMode("import")}>
        <ArrowDownToLineIcon />
        {t("outcome_transfer.import")}
      </SquareButton>
      {transferMode === "export" && (
        <OutcomeExportDialog org={org} onClose={() => setTransferMode(undefined)} />
      )}
      {transferMode === "import" && (
        <OutcomeImportDialog org={org} onClose={() => setTransferMode(undefined)} />
      )}
    </div>
  );
};
